import { isNone } from '@ember/utils';

const BLANK_ERRORS = ["can't be blank", 'cannot be blank'];
export const isCannotBeBlankError = (error: string | null | undefined) =>
  BLANK_ERRORS.any((variation) => !isNone(error) && error.toLowerCase().includes(variation));
